import httpClient from "@/config/axios";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";
import type { GroupResponse } from "@/script/req";
import { useQuery } from "@tanstack/react-query";

export function useGroupNurseGroupsQuery(enabled: boolean) {
  return useQuery({
    queryKey: QUERY_KEYS.auth.switchGroupCandidates(),
    queryFn: async () => {
      const res = await httpClient.get<GroupResponse[]>(
        "/groups/my-admin-groups"
      );
      return res ?? [];
    },
    staleTime: Infinity,
    gcTime: Infinity,
    enabled,
  });
}
